import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  customError: "",
  customWarning: "",
};

export const serviceErrorSlice = createSlice({
  name: "serviceInlineError",
  initialState,
  reducers: {
    setServiceError: (state, action: PayloadAction<string>) => {
      state.customError = action.payload;
    },
    setServiceWarning: (state, action: PayloadAction<string>) => {
      state.customWarning = action.payload;
    },
    resetServiceError: () => initialState,
  },
});

export const {
  setServiceError,
  setServiceWarning,
  resetServiceError,
} = serviceErrorSlice.actions;

export default serviceErrorSlice.reducer;
